module.exports = __webpack_public_path__ + "img/mb-visual-background.482d255d.png";